import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";

const state = {
  authToken: null,
  pdv: null,
  loggedUser: null,
  loginPosData: null,
  eventId: null,
  widgetMode: false,
  step: "Cart",
};

export default {
  state,
  mutations,
  actions,
  getters,
};
